export const tab_en = {
  "THead": "THead",
  "mqs_vmitransfer_tab1": "mqs_vmitransfer_tab1",
  "mqs_vmitransfer_tab0": "mqs_vmitransfer_tab0",
  "user_def_vmit_tab0": "user_def_vmit_tab0"
};

export const tab_zh = {
  "THead": "表头",
  "mqs_vmitransfer_tab1": "杂项",
  "mqs_vmitransfer_tab0": "综合",
  "user_def_vmit_tab0": "用户自定义的_设置1"
} 